<template>
    <div id="showScroll" class="container-ticket">
      <div class="receipt  container-ticket" v-bind:style="dataToTicket.ancho">
        <h1 class="main-title"></h1>
        <div class="address" style="font-size: 14px" v-if="dataToTicket.tenantTicket == 'PCUN'">CLUBS PUERTO CANCUN SA DE CV</div>
        <div class="address" style="font-size: 14px; margin-top:-10px;" v-if="dataToTicket.tenantTicket == 'PCUN'">Regimen general de personas morales</div>
        <div class="address" style="font-size: 16px">{{ dataToTicket.TitleTicket}}</div>
        <div class="address" style="font-size: 14px; margin-top:-10px;" v-if="dataToTicket.tenantTicket == 'PCUN'">CPC210813VDA</div>
  
        
        <div v-html="dataToTicket.DirTicket" class="address">
        </div>
        <div class="detailTicket" v-if="dataToTicket.tenantTicket == 'PCUN'">Cancun Quintana Roo</div>
        <div class="detailTicket">Ticket -{{ dataToTicket.Folio }}</div>
        <div  class="detailTicket">
          Cajero: {{ dataToTicket.cajero ? dataToTicket.cajero.NombreCajero : "" }}
        </div>
        <div class="detailTicket">
          Fecha:
          {{$pgsHelper
              .getDate(dataToTicket.FechaVenta)
              .format("DD-MM-YYYY")}} 
          {{
            $pgsHelper
              .getDate(dataToTicket.FechaCreacion)
              .format("HH:mm")
          }}
        </div>
        <div class="centerItem bold">
          <div class="item">
            Cliente:
            {{
              dataToTicket.Cliente
                ? dataToTicket.Cliente.Nombre
                : "Cliente en general"
            }}
          </div>
        </div>
        <div  class="centerItem transactionDetails survey bold" dense outlined type="">
          *******************************************<br/>
          ************DEVOLUCIÓN**************<br/>
          *******************************************
        </div>
        <div class="survey bold">
          <p>Detalle devolución:</p>
        </div>
        <div style="margin-bottom:10px;" id="tablaDetalle">
          <table style="width: 100%">
            <template v-for="(item, index) in dataToTicket.Catalogo">
              <tr
                :key="index + 10000"
                v-bind:class="{ selectedRow: item.selected }"
              >
                <td width="10%" v-if="(item.Cnt - (item.Dto ? item.Dto : 0)) > 0">{{ item.Cnt - (item.Dto ? item.Dto : 0) }}</td>
                <td width="10%" v-if="(item.Cnt - (item.Dto ? item.Dto : 0)) == 0">{{ item.Cnt }}</td>
  
                <td width="80%">
                  <p v-if="item.Tip == 'RVA-Reserva'">
                    {{ item.Nombre }}|{{ item.Catalogo[0].Nombre }}
                  </p>
                  <p v-else-if="item.Tip == 'RVA-Addon'">
                    {{ item.Nombre }}
                    {{ item.NombreRider ? " | " + item.NombreRider : "" }}
                  </p>
                  <p v-else-if="item.Tip == 'Cupon' || item.Tip == 'Cuenta'">
                    {{ item.Nombre }}
                    <template v-if="item.Tip == 'Cupon'">
                    <br />Folio:{{ item.ExtraParams.Folio }}
                    <template v-for="(cupItem,indexcatcupon) in item.Catalogo">
                      <li :key="indexcatcupon">
                        {{ cupItem.Cnt }} {{ cupItem.Nombre }} {{cupItem.Catalogo[0].Nombre}}
                      </li>
                    </template>
                  </template>
                  <template v-if="item.Tip == 'Cuenta'">
                    <template v-for="(cupItem,indexcatCuenta) in item.Catalogo">
                      <li :key="indexcatCuenta">
                        {{ cupItem.Cnt }} {{ cupItem.Nombre }} ${{ $pgsHelper.formatNumber(cupItem.Pco.C * cupItem.Cnt)}}
                      </li>
                    </template>
                  </template>
                  </p>
                  <p v-else>{{ item.Nombre }}</p>
                </td>
                <td width="10%" v-if="!dataToTicket.sinPrecio && ((item.Cnt - (item.Dto ? item.Dto : 0)) > 0)">${{$pgsHelper.formatNumber( (item.Cnt - (item.Dto ? item.Dto : 0)) * item.Pco.C )}} {{ (item.Pco.M === 'MXN')?'':item.Pco.M }}</td>
                <td width="10%" v-if="!dataToTicket.sinPrecio && ((item.Cnt - (item.Dto ? item.Dto : 0)) == 0)">${{$pgsHelper.formatNumber( (item.Cnt) * item.Pco.C )}} {{ (item.Pco.M === 'MXN')?'':item.Pco.M }}</td>
  
              </tr>
              
              <template v-for="(modi, indexModi) in item.ModificadoresList">
                <tr
                  :key="index + 30000 + indexModi + 'Modificador'+item.Id+$pgsHelper.token()"
                  style="font-size: 15px"
                >
                  <td width="10%" class="promoItem">
                    {{modi.Cnt}}
                  </td>
                  <td width="80%">{{ modi.nam}}</td>
                  <td width="20%"  v-if="!dataToTicket.sinPrecio"> ${{ modi.Cnt * modi.pco.C}} {{ (modi.pco.M === 'MXN')?'':modi.pco.M}}</td>
                </tr>
              </template>
              <template v-for="(desc, indexDes) in item.Descuentos">
                <tr
                  v-if="dataToTicket.DescuentosDesglosados & desc.Activo"
                  :key="index + 20000 + indexDes + 'DESC' + item.internalId"
                  style="font-size: 15px"
                >
                  <td width="10%" class="promoItem">
                    {{ desc.Cnt }}
                  </td>
                  <td width="80%">{{ desc.Dsc }}</td>
                  <td width="20%">
                    ${{ desc.Cur.C }} {{ desc.Cur.M === "MXN" ? "" : desc.Cur.M }}
                  </td>
                </tr>
              </template>
            </template>
            <template v-for="(desc, indexDescuento) in dataToTicket.totalDescuentos">
              <tr v-if="!dataToTicket.DescuentosDesglosados" :key="indexDescuento + 'DESCUENTO'" style="font-size: 15px">
                <td width="10%" class="promoItem">1</td>
                <td width="80%">{{ desc.Nombre }}</td>
                <td width="20%">${{ desc.Total }}</td>
              </tr>
            </template>
          </table>
        </div>
        <div class="paymentDetails bold" v-if="dataToTicket.showDefualtTotal">
          <div class="detail">SUBTOTAL</div>
          <div class="detail">${{ dataToTicket.totales ? $pgsHelper.formatNumber((dataToTicket.totales.TotalMxn - dataToTicket.IVA) + Number(dataToTicket.totalDescontar * -1)) : 0 }} MXN</div>
        </div>
        <div class="paymentDetails bold" v-if="dataToTicket.showDefualtTotal && dataToTicket.tenantTicket == 'PCUN'">
          <div class="detail">IVA</div>
          <div class="detail">${{ dataToTicket.IVA ? $pgsHelper.formatNumber(dataToTicket.IVA) : 0 }} MXN</div>
        </div>
        <div class="paymentDetails bold" v-if="dataToTicket.showDefualtTotal">
          <div class="detail">DESCUENTOS</div>
          <div class="detail">${{ dataToTicket.totalDescontar ? $pgsHelper.formatNumber(dataToTicket.totalDescontar) : 0 }} MXN</div>
        </div>
        
        <div class="paymentDetails bold" v-if="dataToTicket.showDefualtTotal">
          <div class="detail">TOTAL DEV</div>
          <div class="detail">-${{ dataToTicket.totales? $pgsHelper.formatNumber(dataToTicket.totales.TotalMxn) : 0 }} MXN</div>
        </div>
        <div class="paymentDetails" v-if="dataToTicket.showDefualtTotal">
          <div style="font-size:12px">{{numToString.num2str(dataToTicket.totales.TotalMxn,"Pesos Mexicanos")}}</div>
        </div>
        
        <div class="paymentDetails bold" v-if="dataToTicket.showDollar">
          <div class="detail">TOTAL USD</div>
          <div class="detail" v-if="!dataToTicket.showRealDollars">-${{ dataToTicket.totales ? $pgsHelper.formatNumber(dataToTicket.totales.TotalUsd) : 0 }} USD</div>
          <div class="detail"  v-if="dataToTicket.showRealDollars">-${{ dataToTicket.totales ? $pgsHelper.formatNumber(dataToTicket.totales.TotalRealUsd) : 0 }} USD</div>
        </div>

       
          <div style="text-align: center !important; margin-top:2px; margin-botom:25px !important;">
            <b>Metodos de pago</b>
          </div >
          <div >
          <div style="text-align:center !important;">**********************</div>
        </div>
        <div v-if="dataToTicket.showDefualtTotal">
          <template v-for="(pago, index) in dataToTicket.Devs">
            <div class="pagos" :key="index">
              {{ fixPayName(index) }} : -{{ $pgsHelper.formatNumber(pago) }}
            </div>
          </template>
        </div>

        <div
          class="creditDetails"
          style="text-align: center; margin-top: 15px; width: 90%"
        >
          <!--<div class="survey bold">
                              <p>Deslinde de responsabilidad</p>
                              <p class="surveyID"></p>  
                          </div>-->
          Reimpresión<br />
          {{ dataToTicket.TextoTicket }}
        </div>
      </div>
    </div>
  </template>
  
  
  
  <script>
  import "../assets/css/ticket.css";
  import { mapGetters } from "vuex";
  import Currencies from "../clases/Currencies.js";
  import numString from "../clases/numString.js"
  export default {
    name: "ticket",
    components: {},
    props: ["dataToTicket"],
    data() {
      return {
        textTicket: "",
        titleTicket:"",
        DirTicket:"",
        numToString:new numString()
      };
    },
    computed: {
    },
    methods: {
      fixPayName(name){
        if(name == "T"){
          return "Transferencia"
        }else if( name == "D"){
          return "Deposito"
        }
        else if( name == "V"){
          return "Visa"
        }
        else if( name == "M"){
          return "Master Card"
        }
        else if( name == "C"){
          return "Cheques"
        }
        else if( name == "A"){
          return "American Express"
        }else{
          return name
        }
      }
    },
    mounted: function () {
    },
    beforeMount: function () {
  
    },
  };
  </script>